/**
 * Test Sessions API — create, list, getByCandidate, get, delete.
 */

import { apiFetch } from './core'

export const testSessions = {
    create: (data) => apiFetch('/tests/sessions', {
        method: 'POST', body: JSON.stringify(data),
    }),
    list: (params = {}) => {
        const qs = new URLSearchParams()
        if (params.status) qs.set('status', params.status)
        if (params.candidate_id) qs.set('candidate_id', params.candidate_id)
        if (params.vacancy_id) qs.set('vacancy_id', params.vacancy_id)
        const q = qs.toString()
        return apiFetch(`/tests/sessions${q ? `?${q}` : ''}`)
    },
    getByCandidate: (candidateId) => apiFetch(`/tests/sessions?candidate_id=${candidateId}`),
    get: (sessionId) => apiFetch(`/tests/sessions/${sessionId}`),
    delete: (sessionId) => apiFetch(`/tests/sessions/${sessionId}`, { method: 'DELETE' }),
}
